export default function(x) {
  var r = Math.exp(x);
  r = (r + 1 / r) / 2;
  return r;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/proj4/lib/common/cosh.js
// module id = 106
// module chunks = 4